// Production origin, no trailing slash.
// https://quantitativesuperintelligencelabs.com/ returns 308 to this host.
// public/prometheus/latest.json must use this origin in each platform url.
export const SITE_ORIGIN = 'https://www.quantitativesuperintelligencelabs.com';

export const PROMETHEUS_VERSION = '0.1.5';

// x64 ships when Prometheus_${version}_x64-setup.exe is added under
// public/prometheus/releases/. The page checks the file before linking to it,
// so a missing build cannot fall through to index.html.
export const INSTALLERS = {
  arm64: {
    arch: 'arm64',
    name: `Prometheus_${PROMETHEUS_VERSION}_arm64-setup.exe`,
    platform: 'Windows 10 or later, ARM64',
    short: 'ARM64',
    button: 'Download for ARM64',
    fine: 'Windows 10 or later, ARM64. Installs for your account.',
  },
  x64: {
    arch: 'x64',
    name: `Prometheus_${PROMETHEUS_VERSION}_x64-setup.exe`,
    platform: 'Windows 10 or later, x64',
    short: 'x64',
    button: 'Download for x64',
    fine: 'Windows 10 or later, x64. Installs for your account.',
  },
};

export const MANIFEST_PATH = '/prometheus/latest.json';

export function installerPath(name) {
  return `/prometheus/releases/${name}`;
}
